import { Component, effect, inject, input, NgZone, output, TemplateRef, viewChild, ChangeDetectionStrategy} from '@angular/core';
import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { filter, map, pairwise, throttleTime } from 'rxjs/operators';
import { NgTemplateOutlet } from '@angular/common';

@Component({
	selector: 'app-incremental-list',
	templateUrl: './incremental-list.component.html',
	styleUrls: ['./incremental-list.component.scss'],
	imports: [CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf, NgTemplateOutlet],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncrementalListComponent<E> {
	private readonly ngZone = inject(NgZone);

	elementen = input.required<E[]>();
	itemSize = input.required<number>();
	loading = input.required<boolean>();
	itemTemplate = input.required<TemplateRef<{ $implicit: E }>>();
	emptyTemplate = input.required<TemplateRef<{}>>();
	loaderTemplate = input<TemplateRef<{}>>();
	exportMode = input<boolean>(false); // Schakel export modus in/uit

	readonly nextPage = output<number>();

	scroller = viewChild<CdkVirtualScrollViewport>('scroller');

	constructor() {
		effect((onCleanup) => {
			const viewport = this.scroller();
			if (!viewport || this.exportMode()) return;

			const subscription = viewport
				.elementScrolled()
				.pipe(
					map(() => viewport.measureScrollOffset('bottom')),
					pairwise(),
					filter(([y1, y2]) => y2 < y1 && y2 < 140),
					throttleTime(200)
				)
				.subscribe(() => {
					this.ngZone.run(() => this.nextPage.emit(this.elementen().length));
				});

			onCleanup(() => subscription.unsubscribe());
		});
	}
}
